export interface CategorySpendSource {
  name: string;
  amountCents: number;
  icon: string;
}

export interface CategorySpendBar extends CategorySpendSource {
  categories: string[];
  grouped: boolean;
  heightPercent: number;
  percent: number;
}

const INDIVIDUAL_BAR_LIMIT = 7;

export function categorySpendChart(
  categorySpend: CategorySpendSource[],
  totalSpentCents: number,
): CategorySpendBar[] {
  const ordered = categorySpend
    .filter((item) => Number.isInteger(item.amountCents) && item.amountCents > 0)
    .map((item) => ({ ...item, categories: [item.name], grouped: false }))
    .sort((a, b) => b.amountCents - a.amountCents || a.name.localeCompare(b.name, "es-MX"));

  const individual = ordered.slice(0, INDIVIDUAL_BAR_LIMIT);
  const remaining = ordered.slice(INDIVIDUAL_BAR_LIMIT);
  const grouped = remaining.length
    ? [{
        name: "Otras categorías",
        amountCents: remaining.reduce((sum, item) => sum + item.amountCents, 0),
        icon: "＋",
        categories: remaining.map((item) => item.name),
        grouped: true,
      }]
    : [];
  const bars = [...individual, ...grouped]
    .sort((a, b) => b.amountCents - a.amountCents || a.name.localeCompare(b.name, "es-MX"));
  const maximumCents = bars[0]?.amountCents ?? 0;

  return bars.map((item) => ({
    ...item,
    percent: totalSpentCents > 0 ? item.amountCents / totalSpentCents * 100 : 0,
    heightPercent: maximumCents > 0 ? item.amountCents / maximumCents * 100 : 0,
  }));
}
